import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Observable } from 'rxjs';
import { EVENT } from 'src/app/shared/constants/dali.constants';
import { OpEnum } from 'src/app/shared/enums/op.enum';
import { Changes, TagEvent } from 'src/app/shared/models/dali-tags.model';
import { SolicitationStatusModel } from 'src/app/shared/models/solicitation-status.model';
import { AbreCuentasService } from 'src/app/shared/services/abre-cuentas/abre-cuentas.service';
import { BitacoraService } from 'src/app/shared/services/bitacora/bitacora.service';
import { CaptureService } from 'src/app/shared/services/capture/capture.service';
import { CopyService } from 'src/app/shared/services/copies/copy.service';
import { HeaderService } from 'src/app/shared/services/header/header.service';
import { NavigationService } from 'src/app/shared/services/navigation/navigation-onboarding.service';
import { ParametersService } from 'src/app/shared/services/parameters/parameters.service';
import { TaggingService } from 'src/app/shared/services/tagging/tagging.service';
import * as uuid from 'uuid';

@Component({
  selector: 'app-attach-documents',
  templateUrl: './attach-documents.component.html',
  styleUrls: ['./attach-documents.component.scss'],
})
export class AttachDocumentsComponent implements OnInit {

  documentList: any[];
  actualElement: string;
  fileMaxSize: number;
  filesTypes: string[];
  httpClient: any;
  solicitationInfo: SolicitationStatusModel;
  onBaseInfo: any;
  disableButton: any = true;

  constructor(
    public copyService: CopyService,
    private headerService: HeaderService,
    private navigationService: NavigationService,
    private parameterService: ParametersService,
    private abreCuentasService: AbreCuentasService,
    private bitacoraService: BitacoraService,
    private taggingService: TaggingService,
    private captureService: CaptureService,
  ) {
    this.headerService.show(false, true, true);
  }

  ngOnInit() {
    // TODO: this.documentList se debe reemplazar por suficiencia documental
    this.documentList = this.abreCuentasService.getDocumentarySufficiencyList();
    this.fileMaxSize = this.parameterService.getSetting(OpEnum.ATTACH_DOCUMENTS).file_max_size_MB;
    this.filesTypes = this.parameterService.getSetting(OpEnum.ATTACH_DOCUMENTS).files_types;
    this.solicitationInfo = this.abreCuentasService.getRequestModel();
    this.setDocumentInput();
  }

  next(code: number) {
    this.tagg('1', this.copyService.copies.attach_documents.back_button, '');
    this.navigationService.nextStep(code.toString());
  }

  setDocumentInput() {
    //// Por alguna razón ahora comienza en 2
    let counter = 2;
    this.documentList.forEach(element => {
      if (element.alreadyUploaded) {
        element.index = 0;
      } else {
        element.index = counter;
        counter ++;
      }
    });
  }

  selectUploadDocument(element: string) {
    this.actualElement = element;
    const input = document.getElementsByName(`input-file-${element}`)[0];
    /* istanbul ignore next */
    if (input) {
      input.click();
    }
  }

  onDocumentChange(event) {
    this.documentList[+this.actualElement].isFileSizeCorrect = true;
    this.documentList[+this.actualElement].isFileTypeCorrect = true;
    const target = event.target as HTMLInputElement;
    const file = (target.files as FileList)[0];
    this.documentList[+this.actualElement].file = file;
    this.documentList[+this.actualElement].fileExists = true;
    /* istanbul ignore next */
    if (file.size > (this.fileMaxSize * 1000000)) {
      this.documentList[+this.actualElement].isFileSizeCorrect = false;
      this.tagg('2', '', this.copyService.copies.attach_documents.exceeds_file_size
      + '' + this.fileMaxSize
      + '' + this.copyService.copies.attach_documents.exceeds_file_size_MB);
    }
    /* istanbul ignore next */
    console.log(file.type);
    console.log(this.filesTypes);
    if (!this.filesTypes.some(element => element === file.type)) {
      this.documentList[+this.actualElement].isFileTypeCorrect = false;
      this.tagg('2', '', 'El documento no es tipo PDF, JPG o PNG.');
    }
    this.setBase64(this.documentList[+this.actualElement].file);
    this.changeButton();
  }

  removeDocument(element: string) {
    const input = (document.getElementsByName(`input-file-${element}`)[0] as HTMLInputElement);
    /* istanbul ignore next */
    if (input) {
      input.value = '';
    }
    this.documentList[+element].fileExists = false;
    this.documentList[+element].isFileSizeCorrect = true;
    this.documentList[+element].isFileTypeCorrect = true;
    delete this.documentList[+element].file;
    this.changeButton();
  }

  areFilesSizeIncorrect() {
    return this.documentList.some(element => !element.isFileSizeCorrect);
  }

  areFilesTypeIncorrect() {
    return this.documentList.some(element => !element.isFileTypeCorrect);
  }

  changeButton() {
    const fileSize = this.documentList.some(element => element.isFileSizeCorrect === false);
    const fileType = this.documentList.some(element => element.isFileTypeCorrect === false);
    const fileRequiredExisR = this.documentList.some(element => element.priority === 'R');
    const fileRequiredExist = this.documentList.some(element => !element.fileExists && element.priority === 'R');
    const fileRequiredExisOpc = this.documentList.some(element => !element.fileExists && element.priority !== 'R');
    if (fileRequiredExisR) {
      if (!fileSize && !fileType && !fileRequiredExist) {
        this.disableButton = false;
      } else {
        this.disableButton = true;
      }
    } else {
      if (!fileSize && !fileType && !fileRequiredExisOpc) {
        this.disableButton = false;
      } else {
        this.disableButton = true;
      }
    }
  }

  areAllFilesUploaded() {
    let uploaded = true;
    for (let docum of this.documentList) {
      if ((docum.priority === 'R') && docum.required_ind) {
        uploaded = false;
      }
        /* istanbul ignore next */
      // if (!docum.file) {
      //   uploaded = false;
      // }
    }
    return uploaded;
  }

  async sendDocuments() {
    const documentsSelected = this.documentList.filter(document => document.file);
    const responseOkList: any[] = [];
    const idFiles = uuid.v4();
    for (let i = 0 ; i < documentsSelected.length; i++) {
      const creationDate = this.solicitationInfo.solicitation_date_history ?
      this.solicitationInfo.solicitation_date_history.split(',')[0] : new Date().toISOString();
      const fielParameter = {
        document: {
          type: this.abreCuentasService.getDocumentInfo().document_type,
          number: this.solicitationInfo.prospects[0].document.number,
        },
        solicitation: {
          solicitation_id: this.solicitationInfo.solicitation_id,
          client_name: this.solicitationInfo.prospects[0].full_name,
          id_files: idFiles,
          total_files: documentsSelected.length,
          solicitation_id_pqr: '',
        },
        client: {
          person_type: 'PN',
        },
        additional_information: {
          name: '',
          key: this.formatDate(creationDate),
        },
      };
      const data = new FormData();
      data.append('dependence_id', this.solicitationInfo.solicitation_id);
      data.append('document_type', documentsSelected[i].archive_type);
      data.append('process_name', 'pnOnboarding');
      data.append('file_id', uuid.v4());
      data.append('file', documentsSelected[i].file);
      data.append('field_parameter', new Blob([JSON.stringify(fielParameter)], { type: 'application/json' }));
      // data.append('field_parameter_2', '');
      const response = await this.captureService.loadDocument(data);
      if (response.code === '200') {
        responseOkList.push(response);
      }
    }

    if (responseOkList.length == documentsSelected.length) {
      this.abreCuentasService.setDocumentsUploaded(true);
      this.setOnBaseIndexation();
      this.tagg('1', this.copyService.copies.attach_documents.next_button, '');
      this.sendBitacora();
      this.next(200);
    }
  }

  sendBitacora() {
    const bitacoraEvent = `document_upload`;
    this.bitacoraService.saveDataInBitacora(bitacoraEvent);
  }

  setOnBaseIndexation() {
    const type = this.solicitationInfo.prospects[0].document.type;
    this.onBaseInfo = {
      identification : this.solicitationInfo.prospects[0].document.number,
      identificationType : type === '1' ? 'CC' : type === '2' ? 'CE' : type === '3' ? 'NIT' : 'TI',
      solicitationDate : this.formatDate(this.solicitationInfo.solicitation_date_history.split(',')[0]),
      documentDate : this.formatDate(new Date().toISOString()),
    };
  }

  formatDate(date: string) {
    const mydate = new Date(date);
    let day = mydate.getDate().toString();
    let month = (mydate.getMonth() + 1).toString();
    const year = mydate.getFullYear();
    /* istanbul ignore else */
    if (+day < 10) {
      day = `0${day}`;
    }
    /* istanbul ignore else */
    if (+month < 10) {
      month = `0${month}`;
    }
    return `${day}/${month}/${year}`;
  }

  setBase64(file) {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      // console.log(reader.result);
    };
    reader.onerror = error => {
      console.log('error: ', error);
    };
  }

  tagg(tag_number: string, label: string, errorName: string) {
    const tagPageName = this.navigationService.getCurrentStep().tag_name;
    try {
      const changes = this.taggingService.createTagChanges(tagPageName, tag_number);
      const event: TagEvent = {
        category: {
          module: EVENT.customCategory.module.body,
          type: EVENT.customCategory.type.link,
          position: EVENT.customCategory.position.center,
        },
        action: EVENT.customAction.click,
        label: this.navigationService.camelize(label),
      };
      switch (tag_number) {
        case '2':
          event.category = {
            module: EVENT.customCategory.module.body,
            type: EVENT.customCategory.type.warning,
            position: EVENT.customCategory.position.top,
          };
          event.action = EVENT.customAction.show;
          event.errorName = this.navigationService.camelize(errorName);
          event.label = EVENT[`${tagPageName}E${tag_number}customLabel`];
          break;
      }
      this.taggingService.pageTagEvent(event, changes);
    } catch (error) {
      console.log(`Error en ${error}`);
    }
  }
}
